<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:19
 * @LastEditTime: 2019-10-11 19:16:56
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="content" v-loading="loading">
    <div class="pageTitle">基础设置</div>

    <el-tabs v-model="activeName" type="card" @tab-click="handleClick1">
      <el-tab-pane label="基础设置" name="first">
        <el-form ref="form1" :model="form1" label-width="160px">
          <el-form-item label="商品未扫码出货:">
            <el-radio-group v-model="form1.radio1" @change="getValue1">
              <el-radio :label="0">不允许查询和参与活动</el-radio>
              <el-radio :label="1">允许查询和参与活动</el-radio>
              <el-radio :label="2">只允许查询，不允许参与活动</el-radio>
            </el-radio-group>
            <el-form-item label="相对于:" label-width="60px">
              <el-radio-group v-model="form1.radio8">
                <el-radio :label="1">总部</el-radio>
                <el-radio :label="2">经销商</el-radio>
                <el-radio :label="3">门店</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form-item>
          <el-form-item label="防伪溯源开启定位:">
            <el-radio-group v-model="form1.is_open_gps">
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
            <span style="color: #ccc; margin-left: 60px"
              >说明：开启此功能后查询防伪溯源时用户授权后获取扫码位置</span
            >
          </el-form-item>
          <el-form-item
            label="查询提示:"
            style="margin-left: 70px"
            v-if="desc1Show"
          >
            <el-col :span="6">
              <el-input
                type="textarea"
                v-model="form1.desc1"
                placeholder=""
                maxlength="120"
              ></el-input>
            </el-col>
            <el-col :span="6" style="margin-top: 25px; margin-left: 6px">
              <span>(限120字以内)</span>
              <!-- <span>(0/16)</span>-->
            </el-col>
          </el-form-item>
          <el-form-item label="经销商、门店禁用后:">
            <el-radio-group v-model="form1.radio2" @change="getValue2">
              <el-radio :label="0">不允许查询和参与活动</el-radio>
              <el-radio :label="1">允许查询和参与活动</el-radio>
              <el-radio :label="2">只允许查询，不允许参与活动</el-radio>
            </el-radio-group>
            <span style="color: #ccc; margin-left: 60px"
              >针对经销商被禁用后，其手里未发出或销售的商品</span
            >
          </el-form-item>
          <el-form-item
            label="查询提示:"
            style="margin-left: 70px"
            v-if="desc2Show"
          >
            <el-col :span="6">
              <el-input
                type="textarea"
                v-model="form1.desc2"
                placeholder=""
                maxlength="120"
              ></el-input>
            </el-col>
            <el-col :span="6" style="margin-top: 25px; margin-left: 6px">
              <span>(限120字以内)</span>
            </el-col>
          </el-form-item>
          <el-form-item label="商品窜货后:">
            <el-radio-group v-model="form1.radio3" @change="getValue3">
              <el-radio :label="0">不允许查询和参与活动</el-radio>
              <el-radio :label="1">允许查询和参与活动</el-radio>
              <el-radio :label="2">只允许查询，不允许参与活动</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="查询提示:"
            style="margin-left: 70px"
            v-if="desc3Show"
          >
            <el-col :span="6">
              <el-input
                type="textarea"
                v-model="form1.desc3"
                placeholder=""
                maxlength="120"
              ></el-input>
            </el-col>
            <el-col :span="6" style="margin-top: 25px; margin-left: 6px">
              <span>(限120字以内)</span>
              <!--<span>(0/16)</span>-->
            </el-col>
          </el-form-item>
          <el-form-item label="标签类型名称:">
            <el-form ref="form2" :model="form2" label-width="80px">
              <el-form-item label="大标:" style="margin-bottom: 10px">
                <el-col :span="4">
                  <el-input v-model="form2.code1" maxlength="4"></el-input>
                </el-col>
                <el-col :span="6" style="margin-top: 10px; margin-left: 6px">
                  <span>(限4字以内)</span>
                </el-col>
              </el-form-item>
              <el-form-item label="中标:" style="margin-bottom: 10px">
                <el-col :span="4">
                  <el-input v-model="form2.code2" maxlength="4"></el-input>
                </el-col>
                <el-col :span="6" style="margin-top: 10px; margin-left: 6px">
                  <span>(限4字以内)</span>
                </el-col>
              </el-form-item>
              <el-form-item label="小标:" style="margin-bottom: 10px">
                <el-col :span="4">
                  <el-input v-model="form2.code3" maxlength="4"></el-input>
                </el-col>
                <el-col :span="6" style="margin-top: 10px; margin-left: 6px">
                  <span>(限4字以内)</span>
                </el-col>
              </el-form-item>
              <span style="color: #ccc">自定义标签类型的名称,如:箱标,盒标</span>
            </el-form>
          </el-form-item>
          <el-form-item label="生产批次号控制:">
            <el-radio-group v-model="form1.radio4">
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
            <span style="color: #ccc; margin-left: 60px"
              >启用后，全局按批次号区分产品信息</span
            >
          </el-form-item>
          <el-form-item label="客户入库确认控制:">
            <el-radio-group v-model="form1.radio5">
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
            <span style="color: #ccc; margin-left: 60px"
              >启用后，所有的出货单后在完成后都需要收货人点击确认入库后才到收货人的库存内</span
            >
          </el-form-item>
          <el-form-item label="PDA出货方式默认值:">
            <el-radio-group v-model="form1.radio6">
              <el-radio :label="0">已入库商品出货</el-radio>
              <el-radio :label="1">快速出货</el-radio>
            </el-radio-group>
            <span style="color: #ccc; margin-left: 60px"
              >选择PDA上默认的出货方式</span
            >
          </el-form-item>
          <el-form-item label="PDA退货审核控制:">
            <el-radio-group v-model="form1.radio7">
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
            <span style="color: #ccc;margin-left: 60px"
              >启用后，所有的退货单自动通过审核</span
            >
          </el-form-item>
          <!-- <el-form-item label="PDA扫描校验物流码位数">
            <el-radio-group v-model="form1.radio7">
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
            <span style="color: #ccc;margin-left: 60px"
              >启用后，扫描的物流码位数与系统所设置的物流码位数不相符</span
            >
          </el-form-item> -->
          <el-form-item label="呆滞品计算周期:">
            <el-col :span="2">
              <el-input
                v-model="form2.cycleTime"
                @input="$forceUpdate()"
              ></el-input>
            </el-col>
            <el-col :span="1" style="margin-left: 20px">
              <span>天</span>
            </el-col>
            <span style="color: #ccc">范围30-3650天，默认300天</span>
          </el-form-item>
          <!-- <el-form-item label="经销商/门店库存预警:">
            <el-col :span="2">
              <el-input v-model="form2.store_stock"></el-input>
            </el-col>
            <span style="color: #ccc; margin-left: 60px"
              >当经销商/门店库存值低于设置的值时,会标红显示</span
            >
          </el-form-item> -->
          <!-- beg喜来健-->
          <el-form-item
            label="门店未确认收货预警:"
            v-if="form1.xljbrand_id == 10000093"
          >
            <el-col :span="2">
              <el-input v-model="form1.xljradio1"></el-input>
            </el-col>
            <span style="color: #ccc; margin-left: 60px"
              >门店超过指定天数未确认收货会在预警列表显示</span
            >
          </el-form-item>
          <el-form-item
            label="门店产品库存预警:"
            v-if="form1.xljbrand_id == 10000093"
          >
            <el-col :span="2">
              <el-input v-model="form1.xljradio2"></el-input>
            </el-col>
            <span style="color: #ccc; margin-left: 60px"
              >门店产品库存值高于设置的值时,会预警列表显示</span
            >
          </el-form-item>
          <!-- eng喜来健-->
          <el-form-item>
            <el-button type="primary" @click="basicSave()">保存</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="物流码设置" name="second">
        <el-tabs
          v-model="activeNameChild"
          type="card"
          @tab-click="handleClick2"
        >
          <el-tab-pane label="位数设置" name="second_one">
            <div class="blocknote">
              扫描物流码操作出入库或退货时，系统会优先判断扫描的物流码位数与所设置的物流码位数是否相符，
              从而提升出入库和退货的速度。
            </div>
            <el-col :span="18" style="margin-top: 10px">
              <ul class="parent">
                <li>
                  <div>
                    <span>大标</span>
                    <el-button type="text" @click="addNumber(1)"
                      >添加位数</el-button
                    >
                  </div>
                  <ul class="child">
                    <li v-for="(item, index) in bigCode">
                      <span class="left">{{ item }}位</span>
                      <span class="right" v-if="item == '6'"
                        >系统内置，不能删除</span
                      >
                      <span
                        class="right"
                        v-if="item !== '6'"
                        @click="delNumber(1, index)"
                        >删除</span
                      >
                    </li>
                  </ul>
                </li>
                <li>
                  <div>
                    <span>中标</span>
                    <el-button type="text" @click="addNumber(2)"
                      >添加位数</el-button
                    >
                  </div>
                  <ul class="child">
                    <li v-for="(item, index) in middleCode">
                      <span class="left">{{ item }}位</span>
                      <span class="right" v-if="item == '7'"
                        >系统内置，不能删除</span
                      >
                      <span
                        class="right"
                        v-if="item !== '7'"
                        @click="delNumber(2, index)"
                        >删除</span
                      >
                    </li>
                  </ul>
                </li>
                <li>
                  <div>
                    <span>小标</span>
                    <el-button type="text" @click="addNumber(3)"
                      >添加位数</el-button
                    >
                  </div>
                  <ul class="child">
                    <li v-for="(item, index) in smallCode">
                      <span class="left">{{ item }}位</span>
                      <span class="right" v-if="item == '8'"
                        >系统内置，不能删除</span
                      >
                      <span
                        class="right"
                        v-if="item !== '8'"
                        @click="delNumber(3, index)"
                        >删除</span
                      >
                    </li>
                  </ul>
                </li>
              </ul>
            </el-col>
          </el-tab-pane>
          <el-tab-pane label="截取URL设置" name="second_two">
            <div class="blocknote">
              添加URL地址后，扫描了一码多用的二维码进行出入库或退货时，系统自动截取所填写的URL地址前缀，读取截取URL地址后的内容作为物流码
            </div>
            <el-col :span="18" style="margin-top: 10px">
              <ul class="parent">
                <li>
                  <div>
                    <span>URL地址</span>
                    <el-button type="text" @click="addUrl()">添加URL</el-button>
                  </div>
                  <ul class="child">
                    <li v-for="(item, index) in spliceUrlArray">
                      <span class="left">{{ item }}</span>
                      <span class="right" @click="delUrl(index)">删除</span>
                    </li>
                  </ul>
                </li>
              </ul>
            </el-col>
          </el-tab-pane>
        </el-tabs>

        <el-button type="primary" @click="codeSave()">保存</el-button>
      </el-tab-pane>

      <el-tab-pane label="功能权限设置" name="3">
        <permission />
      </el-tab-pane>
      <!--  -->
      <el-tab-pane label="在线订单设置" name="4" v-if="is_showOrder">
        <order />
      </el-tab-pane>
    </el-tabs>
    <!--添加位数-->
    <addNumberDialog
      v-if="addNumberDialogVisable"
      v-on:handleClose="addNumberDialogVisable = false"
      :type="numType"
      :numberArr="numberArr"
      @pushData="getNum"
    >
    </addNumberDialog>
    <!--添加URl-->
    <addUrlDialog
      v-if="addUrlDialogVisable"
      v-on:handleClose="addUrlDialogVisable = false"
      :spliceUrlArray="spliceUrlArray"
      @pushData="getUrl"
    >
    </addUrlDialog>
  </div>
</template>
<script>
import addNumberDialog from "./addNumberDialog";
import addUrlDialog from "./addUrlDialog";
import permission from "./components/permission";
import order from "./components/order";
import VueCookie from "vue-cookie";
export default {
  name: "basic-setting",
  components: {
    addNumberDialog,
    addUrlDialog,
    permission,
    order,
  },
  data() {
    return {
      addNumberDialogVisable: false,
      addUrlDialogVisable: false,
      activeName: "first",
      activeNameChild: "second_one",
      form1: {
        is_open_gps: "",
        radio1: "",
        desc1: "商品未扫码出货，无法参与活动！",
        desc2: "商品未经正规渠道出货，谨防假冒！（经销商被禁用)",
        desc3: "商品未经正规渠道出货，无法参与活动！",
        radio2: "",
        radio3: "",
        radio4: "",
        radio5: "",
        store_stock: "",
        cycleTime: "", //呆滞品周期
        radio6: "",
        radio7: "",
        radio8: "",
        radio9: "",
        radio10: "",
        radio11: "",
        radio12: "",
        allStore: "",
        allDealer: "",
        allWorker: "",
        //喜来健
        xljradio1: "",
        xljradio2: "",
        xljbrand_id: "",
      },
      form3: {},
      desc1Show: false,
      desc2Show: false,
      desc3Show: false,
      form2: {
        code1: "大标",
        code2: "中标",
        code3: "小标",
      },
      bigCode: [], //大标
      middleCode: [], //中标
      smallCode: [], //小标
      spliceUrlArray: [], //截取url
      numType: 0, //添加的位数类型
      numberArr: [], //传给子组件
      loading: false,
      inventoryShow: false,
      retailShow: false,
      transfersShow: false,
      onlineOrdersShow: true,
      is_showOrder: true,
    };
  },
  methods: {
    getShowOrder() {
      this.$get("logistics_2", "publics/Dealerpc.Dealerpc/logisticsorder", {
        customer_id: VueCookie.get("customer_id"),
      }).then((res) => {
        if (res.code == 200) {
          this.is_showOrder = res.is_show_order;
        }
      });
    },
    init() {
      if (this.$route.query && this.$route.query.order) {
        this.activeName = "4";
      }
    },
    //获取基础配置
    getConfig() {
      this.$get("logistics", "/configs", {
        lang: "",
      })
        .then((res) => {
          this.form1.is_open_gps = res.data.is_open_gps;
          this.form1.radio1 = res.data.no_scan_warehouse_out_status;
          this.form1.radio2 = res.data.forbidden_status;
          this.form1.radio3 = res.data.fleeing_goods_status;
          this.form1.radio4 = res.data.production_batch_on_off;
          this.form1.radio5 = res.data.warehousing_confirm;
          this.form1.radio6 = res.data.pda_out_warehouse_type;
          this.form1.radio7 = res.data.return_auto_verify_on_off;
          this.form1.store_stock = res.data.store_stock;
          this.form1.desc1 = res.data.no_scan_warehouse_out_msg;
          this.form1.desc2 = res.data.forbidden_msg;
          this.form1.desc3 = res.data.fleeing_goods_msg;
          this.form1.radio8 = res.data.no_scan_warehouse_out_type || 0;
          this.form2.code1 = res.data.big_code_name;
          this.form2.code2 = res.data.middle_code_name;
          this.form2.code3 = res.data.small_code_name;
          this.form2.cycleTime = res.data.dead_stock;
          this.getValue1(this.form1.radio1);
          this.getValue2(this.form1.radio2);
          this.getValue3(this.form1.radio3);
          //喜来健
          this.form1.xljbrand_id = res.data.pps_id;
          this.form1.xljradio1 = res.data.store_not_inwarehouse_overtop;
          this.form1.xljradio2 = res.data.store_stock_overtop;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //获取物流码
    getCodeConfig() {
      this.$get("logistics", "/codeconfigs", {
        lang: "",
      })
        .then((res) => {
          this.bigCode = res.data.big_code_lengths;
          this.middleCode = res.data.middle_code_lengths;
          this.smallCode = res.data.small_code_lengths;
          this.spliceUrlArray = res.data.cut_out_urls;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //基础信息枚举格式化
    /*  format(val){
                switch (val){
                    case 0:
                        return 0;
                        break;
                    case 1:
                        return 1;
                        break;
                    case 2:
                        return 2;
                        break;
                    default:
                        break;
                }

            },*/
    getValue1(value) {
      switch (value) {
        case 0:
          this.desc1Show = true;
          break;
        case 1:
          this.desc1Show = false;
          break;
        case 2:
          this.desc1Show = true;
          break;
        default:
          break;
      }
    },
    getValue2(value) {
      switch (value) {
        case 0:
          this.desc2Show = true;
          break;
        case 1:
          this.desc2Show = false;
          break;
        case 2:
          this.desc2Show = true;
          break;
        default:
          break;
      }
    },
    getValue3(value) {
      switch (value) {
        case 0:
          this.desc3Show = false;
          break;
        case 2:
          this.desc3Show = true;
          break;
        default:
          break;
      }
    },
    getValue4(value) {
      switch (value) {
        case 1:
          this.inventoryShow = true;
          break;
        case 2:
          this.inventoryShow = false;
          break;
        default:
          break;
      }
    },
    getValue5(value) {
      switch (value) {
        case 1:
          this.retailShow = true;
          break;
        case 2:
          this.retailShow = false;
          break;
        default:
          break;
      }
    },
    getValue6(value) {
      switch (value) {
        case 1:
          this.transfersShow = true;
          break;
        case 2:
          this.transfersShow = false;
          break;
        default:
          break;
      }
    },
    //获取位数
    getNum(val) {
      if (val[1] == 1) {
        this.bigCode.push(val[0]);
      } else if (val[1] == 2) {
        this.middleCode.push(val[0]);
      } else {
        this.smallCode.push(val[0]);
      }
    },
    //添加位数
    addNumber(type) {
      this.addNumberDialogVisable = true;
      this.numType = type;
      this.numberArr = [];
      if (type == 1) {
        for (var i = 0; i < this.bigCode.length; i++) {
          this.numberArr.push(this.bigCode[i]);
        }
      } else if (type == 2) {
        for (var i = 0; i < this.middleCode.length; i++) {
          this.numberArr.push(this.middleCode[i]);
        }
      } else {
        for (var i = 0; i < this.smallCode.length; i++) {
          this.numberArr.push(this.smallCode[i]);
        }
      }
    },
    //删除位数
    delNumber(type, index) {
      if (type == 1) {
        this.bigCode.splice(index, 1);
      } else if (type == 2) {
        this.middleCode.splice(index, 1);
      } else {
        this.smallCode.splice(index, 1);
      }
    },
    //获取url
    getUrl(val) {
      this.spliceUrlArray.push(val);
    },
    //添加url
    addUrl() {
      this.addUrlDialogVisable = true;
    },
    //删除url
    delUrl(index) {
      this.spliceUrlArray.splice(index, 1);
    },
    //基础设置的保存
    basicSave() {
      if (this.form2.cycleTime < 30 || this.form2.cycleTime > 300) {
        this.$message({
          type: "error",
          message: "呆滞品周期设置有误",
        });
        return;
      }
      this.loading = true;
      this.$put("logistics", "/configs", {
        lang: "",
        _method: "PUT",
        is_open_gps: this.form1.is_open_gps,
        no_scan_warehouse_out_status: this.form1.radio1,
        no_scan_warehouse_out_type: this.form1.radio8,
        no_scan_warehouse_out_msg: this.form1.desc1,
        forbidden_status: this.form1.radio2,
        forbidden_msg: this.form1.desc2,
        fleeing_goods_status: this.form1.radio3,
        fleeing_goods_msg: this.form1.desc3,
        big_code_name: this.form2.code1,
        middle_code_name: this.form2.code2,
        small_code_name: this.form2.code3,
        production_batch_on_off: this.form1.radio4,
        warehousing_confirm: this.form1.radio5,
        pda_out_warehouse_type: this.form1.radio6,
        return_auto_verify_on_off: this.form1.radio7,
        dead_stock: this.form2.cycleTime,
        store_stock_overtop: this.form1.xljradio1,
        store_not_inwarehouse_overtop: this.form1.xljradio2,
      })
        .then((res) => {
          //console.log(res);
          this.loading = false;
          if (res.message == "操作成功") {
            this.$message({
              type: "success",
              message: "保存成功!",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: error.message,
          });
        });
    },
    //物流吗保存
    codeSave() {
      this.$put("logistics", "/codeconfigs", {
        lang: "",
        _method: "PUT",
        big_code_lengths: JSON.stringify(this.bigCode),
        middle_code_lengths: JSON.stringify(this.middleCode),
        small_code_lengths: JSON.stringify(this.smallCode),
        cut_out_urls: JSON.stringify(this.spliceUrlArray),
      })
        .then((res) => {
          if (res.message == "操作成功") {
            this.$message({
              type: "success",
              message: "保存成功!",
            });
          }
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error.message,
          });
        });
    },
    handleClick1(tab, event) {
      /*if(tab.label == '物流码设置'){
                    this.getCodeConfig();
                }else{
                    this.getConfig();
                }*/
    },
    handleClick2(tab, event) {
      //this.getCodeConfig();
    },
  },
  created() {
    this.init();
    this.getConfig();
    this.getCodeConfig();
    this.getShowOrder();
  },
  filters: {},
};
</script>
<style lang="scss" scoped>
.blocknote {
  height: 14px;
  line-height: 14px;
  background-color: #ccc;
  padding: 20px;
}

.parent {
  background-color: #fff;
  li {
    padding: 20px 80px;
    div {
      padding-left: 20px;
      height: 50px;
      line-height: 50px;
      border: 1px solid #ccc;
      span {
        float: left;
      }
      .el-button {
        line-height: 26px;
        float: right;
        margin-right: 20px;
      }
    }
    .child {
      margin-left: 40px;
      margin-top: 10px;
      li {
        padding-left: 20px;
        padding-right: 20px;
        height: 2px;
        margin-bottom: 10px;
        line-height: 2px;
        border: 1px solid #ccc;
        .left {
          float: left;
        }
        .right {
          float: right;
          cursor: pointer;
        }
      }
    }
  }
}
.goodsType {
  margin: 20px 0;
  li {
    height: 40px;
    margin-bottom: 10px;
    background-color: #ccc;
    color: #fff;
    font-size: 16px;
    padding: 0 20px;
    .left {
      float: left;
    }
    .right {
      float: right;
      span {
        color: blue;
        cursor: pointer;
        margin-left: 20px;
      }
    }
  }
}
</style>
